export default __webpack_public_path__ + "static/media/sales.d15f7933.jpeg";